import { render, staticRenderFns } from "./PersonRole.vue?vue&type=template&id=0a2c7d14&scoped=true"
import script from "./PersonRole.vue?vue&type=script&lang=js"
export * from "./PersonRole.vue?vue&type=script&lang=js"
import style0 from "./PersonRole.vue?vue&type=style&index=0&id=0a2c7d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c7d14",
  null
  
)

export default component.exports